<template>
  <component
    :key="item.key"
    v-bind="item.props || {}"
    :is="getComponent(item.component)"
    :value="get(item.key)"
    :data-field="item.dataField || item.key"
    :disabled="Boolean(item.disabled)"
    @input="$ev => set(item.key, $ev)"
    :validator="validator"
    :isValid="item.validationKey ? validator.fields[item.validationKey].valid : true"
    :validationMessage="item.validationKey ? validator.fields[item.validationKey].error : ''"
    v-tooltip.bottom="item.disabled"
  >
    <template v-for="(slotItems, slot) in item.slots" v-slot:[slot]="slotScope">
      <component
        v-for="(slotItem, index) of slotItems"
        :key="item.key + slot + index"
        v-bind="{ ...slotItem.props, ...slotScope }"
        :is="getComponent(slotItem.component)"
        :value="$path('props.value', slotItem) || get(item.key)"
        @input="$ev => set(item.key, $ev)"
      />
    </template>
  </component>
</template>

<script>
import { setByPath } from '@/utils'
import { MediaComponent } from '@kvass/media'
import MediaRecommendation from '@/components/MediaRecommendation'
import RichTextComponent from '@kvass/rich-text'
import MediaOnDrop from '@/components/vendors/kvass-media/onDrop'
import { InputComponent } from 'vue-elder-input'
import { DropdownComponent } from 'vue-elder-dropdown'
import InputDate from '@/components/InputDate'
import UserSelect from '@/components/User/Select/Modal'
import Publishing from './Publishing.vue'

export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    validator: {
      type: Object,
      default: () => ({}),
    },
    item: {
      type: Object,
      default: () => ({}),
    },
    placement: {
      type: String,
    },
  },
  methods: {
    get(key) {
      return this.$path(key, this.value)
    },
    set(key, value) {
      setByPath(key, value, this.value)
    },

    getComponent(item) {
      const items = {
        MediaComponent: MediaComponent,
        DropdownComponent: DropdownComponent,
        InputComponent: InputComponent,
        MediaRecommendation: MediaRecommendation,
        RichTextComponent: RichTextComponent,
        InputDate,
        UserSelect,
        Publishing,
        MediaOnDrop: MediaOnDrop,
      }

      return items[item] || item
    },
  },
}
</script>

<style lang="scss"></style>
